<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType" 
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-row v-if="!(storeOrders && storeOrders.length == 0 && storeOrdersInfo.currentPage == 1 && !loadingData && !loadingClear && search == null && status == null && sortLastCreated == false)">
      <v-col cols="11" class="mx-auto pt-2 pb-0">
          <SearchBarExpanding @input="searchOrders" @resetSearch="resetSearch"/>
      </v-col>
      <v-col
        :cols="mobile() ? '12' : '11'"
        class="mx-auto d-flex align-right justify-end mt-6"
      >
        <div>
          <v-btn 
            text 
            @click="clearFilter()" 
            class="text-body-2 text-none no-hover"
            :ripple="false"
          >
            {{ $t('clear') }}
          </v-btn>
          <SortOptions :sort-last-created="sortLastCreated" @setSort="setSort"/>
          <v-menu
            v-model="filterMenu"
            width="360"
            max-width="360"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="rounded-xxl text-none px-4 ml-3"
                data-testid="orders-filter-button"
              >
                {{ status ? $t(status) : $t('status') }}
                <v-icon
                  right
                  color="accent"
                >
                  mdi-chevron-down
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item data-testid="orders-filter-pending" @click="setFilter('pending')">
                <v-list-item-title>{{ $t('pending') }}</v-list-item-title>
              </v-list-item>
              <v-list-item data-testid="orders-filter-approved" @click="setFilter('approved')">
                <v-list-item-title>{{ $t('approved') }}</v-list-item-title>
              </v-list-item>
              <v-list-item data-testid="orders-filter-denied" @click="setFilter('denied')">
                <v-list-item-title>{{ $t('denied') }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-col>
    </v-row>
    <v-row
      v-if="storeOrders.length > 0 && !loadingData"
      align="center"
      class="mx-auto py-5"     
    >
      <v-col
        cols="11"
        class="mx-auto pa-0"
         v-for="(order) in storeOrders"
          :key="order.id"
      >
       <v-row>
        <v-col cols="11" class="pa-0">
          <v-card
            :ripple="false"
            data-testid="store-order-card"
            rounded="xxl"
            class="mb-2 solo"
            @click="showOrderDetail(order.id)"
          >
            <v-hover v-if="mobile()">
              <v-row
                v-if="mobile()"
                slot-scope="{ hover }"
                no-gutters
                :class="`py-3 elevation-${hover? 8 : 2 }`"
              >
                <v-col
                  cols="11"
                  align-self="center"
                  class="px-6"
                >
                  <v-card-text class="text-body-2 darktext--text pa-0 text-no-wrap text-truncate d-block">
                    {{ order.attributes.company_name }}
                  </v-card-text>
                </v-col>
                <v-col
                  cols="1"
                  class="text-right d-flex align-center justify-end three-dots"
                >
                </v-col>
              </v-row>
            </v-hover>
            <v-hover v-if="!mobile()">
              <v-row
                v-if="!mobile()"
                slot-scope="{ hover }"
                no-gutters
                :class="`py-3 elevation-${hover? 8 : 2 }`"
              >
                <v-col
                  cols="12"
                  md="5"
                  lg="5"
                  class="px-6"
                >
                  <div class="text-body-2 grey--text justify-left">
                    {{ $t('labelCompany') }}
                  </div>
                  <div class="text-body-1 darktext--text">
                    {{ order.attributes.company_name }}
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                  lg="5"
                  class="px-6"
                >
                  <div class="text-body-2 grey--text justify-left">
                    {{ $t('labelOrderNumber') }}
                  </div>
                  <div class="text-body-1 darktext--text">
                    {{ order.attributes.number }}
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  md="2"
                  lg="2"
                  class="text-right "
                >
                  <div class="text-body-1 darktext--text d-inline-flex align-center  justify-end pr-5" v-if="order.attributes.approved == true" 
                  :class="`pr-${order.attributes.approved && order.meta.approval_method !== null? 11 : 5 } `"
                  >
                  <v-chip class="chip ma-2" color="success" text-color="white">
                    {{ $t('approved') }}
                  </v-chip> <v-tooltip
              bottom>
              <template v-slot:activator="{ on }"><v-icon v-on="on" class="pa-0 darktext--text"  v-if="order.attributes.approved && order.meta.approval_method == null"  data-testid="icon-file" @click.stop="openOrderDocument(order.id)" > mdi-file-document-outline </v-icon>
              </template>
              <span>{{ $t('downloadOrderInvoiceTooltip') }}</span>
            </v-tooltip>
                  </div>
                  <div class="text-body-1 darktext--text d-inline-flex align-center  justify-end pr-11" v-if="order.attributes.approved == null">
                  <v-chip class="chip ma-2" color="darktext" text-color="white">
                    {{ $t('pending') }}
                  </v-chip>
                  </div>
                    <div class="text-body-1 darktext--text d-inline-flex align-center  justify-end pr-11" v-if="order.attributes.approved == false">
                    <v-chip class="chip ma-2" color="error" text-color="white">
                      {{ $t('denied') }}
                    </v-chip>
                  </div>
                </v-col>
              </v-row>
            </v-hover>
          </v-card>
        </v-col>
        <v-col cols="1" class="text-center align-self-center pa-0" v-if="order.attributes.approved == null">
         <v-icon class="ml-auto" color="orange">mdi-information</v-icon>
        </v-col>
       </v-row>
      </v-col>
    </v-row>
    <Pagination
      v-if="storeOrders.length > 0"
      v-model="pageNumber"
      class="mb-16"
      circle
      :data-length="storeOrdersInfo.total"
      :page-number="storeOrdersInfo.currentPage"
      total-visible="5"
      :size="size"
      @input="handlePageChange"
      :key="paginationKey"
    />
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import { getStoreOrders, downloadInvoiceOrderData, searchStoreOrders } from '../../api/productApi'
import AlertMessages  from '../../components/AlertMessages'
import Pagination from '../../components/Pagination'
import SearchBarExpanding from '../../components/SearchBarExpanding'
import SortOptions from '../../components/SortOptions'

export default {
    components: {
        AlertMessages,
        Pagination,
        SearchBarExpanding,
        SortOptions
    },
    mixins: [repeatedMethodsMixin],
    data(){
        return{
          storeOrders: [],
          alertType: '',
          alertMsg: '',
          alertValue:false,
          spaceId: window.$cookies.get('space_id'),
          loadingData: false,
          storeOrdersInfo: {
            currentPage: 1,
            total: 1,
          },
          size: 15,
          pageNumber: 1,
          paginationKey: '',
          userId: window.$cookies.get('id'),
          downloadingPDF: false,
          search: null,
          totalOrders: 0,
          status: null,
          filterMenu: false,
          sortMenu: false,
          sortLastCreated: false,
          loadingClear: false
        }
    },
    async created(){      
        this.loadingData = true
        await this.fetchStoreOrders()
        this.loadingData = false
    },
    methods:{
        showOrderDetail(id){
            this.$router.push({path: '/store/order/' + id })
        },
        handlePageChange(value){
            this.storeOrdersInfo.currentPage = value
            this.pageNumber = value
            if(this.search == null){
              this.fetchStoreOrders()
            }else {
              this.searchOrders(this.search)
            }
        },

        async searchOrders(keyword){
          this.search = keyword
            if(keyword && keyword.trim().length >= 2){
              try {
                  const response = await searchStoreOrders(this.spaceId,keyword,this.pageNumber, this.size, this.status, this.sortLastCreated)
                  if(response){
                      if(response.status == 200){
                        this.storeOrders = response.data.data
                        if(this.storeOrders.length == 0 && response.data.meta.page.total > 0){
                            this.pageNumber = 1
                            await this.searchOrders(keyword)
                        }else {
                            this.storeOrdersInfo = response.data.meta.page
                            if(this.pageNumber == 1){
                              this.paginationKey = Date.now()
                            }
                            window.scrollTo(0,0)
                        }
                      }
                  }
              } catch (e) {
                  if(e.response){
                      this.error = true
                      this.alertType = 'error'
                      this.alertMsg =  i18n.t('serverError')
                      this.alertValue = true
                  } 
              }
            }
        },
        async resetSearch(){
          this.storeOrdersInfo.currentPage = 1
          this.pageNumber = 1
          await this.fetchStoreOrders()
          this.search = null
          this.paginationKey = Date.now()
          return
        },

        async fetchStoreOrders(){
            try {
                const response = await getStoreOrders(this.spaceId, this.pageNumber, this.size, this.status, this.sortLastCreated)
                if(response.status){
                    if(response.status == 200) {
                        this.storeOrders = response.data.data
                        if(this.storeOrders.length == 0 && response.data.meta.page.total > 0){
                            this.pageNumber = 1
                            await this.fetchStoreOrders()
                        }else {
                          this.storeOrdersInfo = response.data.meta.page
                          this.totalOrders = response.data.meta.page.total
                          if(this.pageNumber == 1){
                            this.paginationKey = Date.now()
                          }
                          window.scrollTo(0,0)
                        }
                    }
                }
            } catch (e) {
                if(e.response){
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                }
            }
        },
        async openOrderDocument(orderId) {
            try {
                    const response = await downloadInvoiceOrderData(orderId);
                    if (response.status) {
                    if (response.status == 200) {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'invoice-order.pdf');
                        document.body.appendChild(link);
                        link.click();
                    }
                    }
                } catch (e) {
                    if (e.response) {
                    this.alertValue = true;
                    this.alertType = "error";
                    this.alertMsg = i18n.t("serverError");
                    }
                }
        },

        async setFilter(status){
          this.loadingClear = true
          this.status = status
          if(this.search == null){
            await this.fetchStoreOrders()
          }else{
            await this.searchOrders(this.search)
          }
          this.loadingClear = false
        },

        async setSort(option){
          if(option == 'lastCreated'){
            this.sortLastCreated = true
            if(this.search == null){
              await this.fetchStoreOrders()
          }else{
              await this.searchOrders(this.search)
            }
          }
        },

        clearFilter(){
          this.status = null
          this.sortLastCreated = false
          this.setFilter(this.status)
        }
    }
}
</script>
<style>
  .chip {
    width: 100px;
    height: 30px;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>